import React from 'react';

interface ActionButtonsProps {
  onBuy: () => void;
  onSell: () => void;
  onDeposit: () => void;
  onWithdraw: () => void;
}

export default function ActionButtons({
  onBuy,
  onSell,
  onDeposit,
  onWithdraw,
}: ActionButtonsProps) {
  return (
    <div className="action-buttons">
      <button className="btn-action btn-buy" onClick={onBuy}>
        📈 Buy
      </button>
      <button className="btn-action btn-sell" onClick={onSell}>
        📉 Sell
      </button>
      <button className="btn-action btn-deposit" onClick={onDeposit}>
        💵 Deposit
      </button>
      <button className="btn-action btn-withdraw" onClick={onWithdraw}>
        🏦 Withdraw
      </button>
    </div>
  );
}
